import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { settings } from '../../../../settings';
import { rendererLogger } from '../../app/Logger';
const logger = rendererLogger('baseQuery');
export const baseQuery = ({
  baseUrl,
  credentials = 'include',
}: {
  baseUrl?: string;
  credentials?: RequestCredentials;
} = {}) =>
  fetchBaseQuery({
    baseUrl: `${baseUrl || settings.API_DOMAIN}/`,
    credentials,
    prepareHeaders: async (headers) => {
      try {
        const isAuthenticated = await window.dsDesktop.user.isAuthenticated();

        if (isAuthenticated) {
          const accessToken = await window.dsDesktop.user.getAccessToken();
          if (accessToken)
            headers.set('Authorization', `Bearer ${accessToken}`);
        }
      } catch (e) {
        logger.info('electron onlineStatus is still undefined', { error: e });
      }

      return headers;
    },
    fetchFn: async (...args) => {
      const response = await fetch(...args);

      if ([403, 401].includes(response.status)) {
        logger.error('Authentication error', { response });
      }

      if (response.status === 400) {
        logger.error('Bad Request', { response });
      }

      if (response.status >= 404 && response.status < 500) {
        logger.error('Error', { response });
      }

      if (response.status >= 500) {
        logger.error('Internal error', { response });
      }

      return response;
    },
  });
